import React,{useState,useEffect} from "react";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import { useParams ,useHistory, useRouteMatch,} from "react-router-dom";
import { useDispatch } from "react-redux";

import { useSelector } from "react-redux";
import {Minus,Activity ,ChevronLeft,X,Plus ,Phone,Check,Video,MonitorPlay,BookOpenCheck,
    TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus,
    HopIcon} from 'lucide-react';

import SectionsQuizAddMore from "./SectionsQuizAddMore";
import CreateSectionPopUp from "./CreateSectionPopUp";
import { createNewMockTest,createNewMockSection,getSectionsByQuizId, getQuizDataByQuizId, getOptionsByQuestionId, createNewQuestionsOption } from "../../../../store/actions/CreateContent/QuizAPI/createNewMockTest";
import Toggle from "../../../UI/Toggle";
import Snackbar from "../../../../Snackbar";
import SectionsQuizAddMoreLoading from "./SectionsQuizAddMoreLoading";
import CreateQueOptionPopUp from "./CreateQueOptionPopUp";
import MCQOptionDisplay from "./MCQOptionDisplay";

  
const QuestionOptions= ({questionObject,questionType})=>{ 
  
  const history = useHistory();
   const dispatch = useDispatch();
   const [snackbarVisible, setSnackbarVisible] = useState(false);
   const [snackbarColor, setSnackbarColor] = useState("#958FDA");
   const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
 
    const [itemArrLoading, setItemArrLoading] = useState([{},{}]);
           
  const [selectedItemIndex, setSelectedItemIndex] = useState(null); 
  
    const showSnackbar = () => {
        setSnackbarVisible(true);
      };
      
       const hideSnackbar = () => {
        setSnackbarVisible(false);
      };
      const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
      {
        
        dispatch({type: "CURSOR",payload:true  });
    
        dispatch({type: "CURSORTEXT",payload:CursorText})
        dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
        dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
      }
       
      const handleMouseLeave = () => {
        
        dispatch({type: "CURSOR",payload:false})
    
        dispatch({type: "CURSORTEXT",payload:""})
    
        dispatch({type: "CURSORTEXTBG",payload:""})
        dispatch({type: "CURSORTEXTCOLOR",payload:""})
      
    
    }
      
      ;
      
     const token = useSelector((state)=>state?.course?.course?.token);
     const currentToken = useSelector((state)=>state?.user?.user?.token);
     const user_email = useSelector((state)=>state?.user?.user?.user_email
    );
    
    const postIdCourse = useSelector((state)=>state?.course?.course?.postId);
    
    const courseData = useSelector((state)=>state?.course?.course);
    
    const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
    const appId = useSelector((state)=>state?.app?.app?.ID);
    const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);
    
     const [loader , setLoader] =useState({status:false});
     const [animate, setAnimate] = useState(false);
    
         const [deleteSectionPopUp, setDeleteSectionPopUp] = useState(false);
         const [deleteId, setDeleteId] = useState("");
            const [isLockSections, setIsLockSections] = useState();
      const [createNewOptionPopUp, setCreateNewOptionPopUp] = useState(false);
    // let allSections= allSectionsData
const [parentFolder, setParentFolder] = useState({ID:""});
    
        const [allSections, setAllSections] = useState([]);
        const [currentOption, setCurrentOption] = useState({});
        
       
        const [ visibility, setVisibility] = useState("public");
        const [ objectNew, isObjectNew] = useState(false);
          
 const [itemArr, setItemArr] = useState(allSections);
   let newOption= {
      ID: generateTimestamp(),
      questionType: questionType,
      optionText: questionType=="MCQ"?"Describe Option":questionType=="MSQ"?"Describe Option":questionType=="NAT"?"Use Numerical Input For Answer":"",
    optionImg: "",
    partialMarks: "",
    displayType: questionType=="MCQ"?"radio":questionType=="MSQ"?"checkbox":"",
    dropdownValues: "",
    isAllowPartialMarks: "false",
    isCorrect: "false",
    textBoxValue: "",
    optionBoxAlign: "left",
    isSingleRange:"false",
    optionSingle:"1",
    optionRange:JSON.stringify({start:1,end:3}),
    dragOrder:"1"
};

let newOptionFT=[{
      ID: generateTimestamp(),
      questionType: questionType,
      optionText: "True",
    optionImg: "",
    partialMarks: "",
    displayType: "radio",
    dropdownValues: "",
    isAllowPartialMarks: "false",
    isCorrect: "false",
    textBoxValue: "",
    optionBoxAlign: "left",
    isSingleRange:"false",
    optionSingle:"1",
    optionRange:JSON.stringify({start:1,end:3}),
    dragOrder:"1"
},{
      ID: generateTimestamp()+1,
      questionType: questionType,
      optionText: "False",
    optionImg: "",
    partialMarks: "",
    displayType: "radio",
    dropdownValues: "",
    isAllowPartialMarks: "false",
    isCorrect: "false",
    textBoxValue: "",
    optionBoxAlign: "left",
    isSingleRange:"false",
    optionSingle:"1",
    optionRange:JSON.stringify({start:1,end:3}),
    dragOrder:"1"
}];
     useEffect(() => {
        
       
       // Trigger the animation after a delay (e.g., 500ms)
       const timer = setTimeout(() => {
        setAnimate(true);  
      }, 100);
    
       return () => clearTimeout(timer); // Cleanup on unmount
     }, []);
    
    
    
      useEffect(()=>{
         fireGetOptionsDataByQuestionId()
        // setCourseTitleData();
       
      },[])
   


      const handleBack=(e)=>{
  
        setLoader({status:true});
        
        history.goBack();
        }
        
 
    function generateTimestamp() {
        return Math.floor(Date.now() / 1000);
      }

      const removeItem = (id) => {
        const filteredItems = itemArr.filter(item => item.ID !== id);
        setItemArr(filteredItems);
        handleCreateNewOption("deleteItem","",id)
      };
      const updateItemtitle = (ID, optionText,optionId) => {
        const updatedItems = itemArr.map(item =>
          item.ID === ID ? { ...item, optionText :optionText } : item
        
        ); 
        
        if(objectNew){} else{  handleCreateNewOption("optionText",optionText,optionId);}
        setItemArr(updatedItems);
       
      };const updateItemImg = (ID, optionText,optionId) => {
        const updatedItems = itemArr.map(item =>
          item.ID === ID ? { ...item, optionImg :optionText } : item
        
        ); 
        
        if(objectNew){} else{  handleCreateNewOption("optionImg",optionText,optionId);}
        setItemArr(updatedItems);
       
      };
      
       const updateTextBoxValueBack = (ID, textBoxValue,optionId) => {
        const updatedItems = itemArr.map(item =>
          item.ID === ID ? { ...item, textBoxValue :textBoxValue } : item
        
        ); 
        
        if(objectNew){} else{  handleCreateNewOption("textBoxValue",textBoxValue,optionId);}
        setItemArr(updatedItems);
       
      };
      const updateDisplayType = (ID, displayType,optionId) => {
        const updatedItems = itemArr.map(item =>
          item.ID === ID ? { ...item, displayType :displayType } : item
        
        ); 
        
        if(objectNew){} else{  handleCreateNewOption("displayType",displayType,optionId);}
        setItemArr(updatedItems);
       
      };
      
      const updateIsSingleRange = (ID, isSingleRange,optionId) => {
        
        const updatedItems = itemArr.map(item =>
          item.ID === ID ? { ...item, isSingleRange :isSingleRange } : item
        
        ); 
        
        if(objectNew){} else{  handleCreateNewOption("isSingleRange",isSingleRange,optionId);}
        setItemArr(updatedItems);
       
      };const updateOptionSingle = (ID, optionSingle,optionId) => {
        
        const updatedItems = itemArr.map(item =>
          item.ID === ID ? { ...item, optionSingle :optionSingle } : item
        
        ); 
        
        if(objectNew){} else{  handleCreateNewOption("optionSingle",optionSingle,optionId);}
        setItemArr(updatedItems);
       
      };
      
      const updateOptionRange = (ID, optionRange,optionId) => {
        
        const updatedItems = itemArr.map(item =>
          item.ID === ID ? { ...item, optionRange :JSON.stringify(optionRange) } : item
        
        ); 
        
        if(objectNew){} else{  handleCreateNewOption("optionRange",optionRange,optionId);}
        setItemArr(updatedItems);
       
      };
     const updateOptionBoxAlign = (ID, optionBoxAlign,optionId) => {
        const updatedItems = itemArr.map(item =>
          item.ID === ID ? { ...item, optionBoxAlign :optionBoxAlign } : item
        
        ); 
        
        if(objectNew){} else{  handleCreateNewOption("optionBoxAlign",optionBoxAlign,optionId);}
        setItemArr(updatedItems);
       
      };
      
      const updateIsCorrect = (ID, isCorrect,optionId) => {
        const updatedItems = itemArr.map(item =>
          item.ID === ID ? { ...item, isCorrect :isCorrect } : item
        
        ); 
        
        if(objectNew){} else{  handleCreateNewOption("isCorrect",isCorrect,optionId);}
        setItemArr(updatedItems);
       
      };
      
      const updateIsAllowPartialMarks = (ID, isAllowPartialMarks,optionId) => {
        const updatedItems = itemArr.map(item =>
          item.ID === ID ? { ...item, isAllowPartialMarks :isAllowPartialMarks } : item
        
        ); 
        
        if(objectNew){} else{  handleCreateNewOption("isAllowPartialMarks",isAllowPartialMarks,optionId);}
        setItemArr(updatedItems);
       
      };
      
      const updatePartialMarks = (ID, partialMarks,optionId) => {
        const updatedItems = itemArr.map(item =>
          item.ID === ID ? { ...item, partialMarks :partialMarks } : item
        
        ); 
        
        if(objectNew){} else{  handleCreateNewOption("partialMarks",partialMarks,optionId);}
        setItemArr(updatedItems);
       
      };
      const updateItemlockTime = (id, lockTime,optionId) => {
        const updatedItems = itemArr.map(item =>
          item.id === id ? { ...item, lockTime :lockTime } : item
        
        ); 
        
        setItemArr(updatedItems);
      
       handleCreateNewOption("lockTime",lockTime,optionId)
      };
    const flattenedData = itemArr!=[]?Object.values(itemArr):'';

  const flattenedDataLoading = itemArrLoading!=[]?Object.values(itemArrLoading):'';

const [draggedIndex, setDraggedIndex] = useState('');
const [hoveredDropZone, setHoveredDropZone] = useState(null); // Track hovered drop zone

const handleDragStart = (e, index) => {
  
  e.dataTransfer.effectAllowed = 'move';
  e.dataTransfer.setData("dragIndex", index);
  
};

const handleDrop = (e, dropIndex) => {
  const dragIndex = e.dataTransfer.getData("dragIndex");
  if (dragIndex === dropIndex) return;

  const updatedItems = [...itemArr];
  const [draggedItem] = updatedItems.splice(dragIndex, 1);
  updatedItems.splice(dropIndex, 0, draggedItem);

  const reorderedItems = updatedItems.map((item, index) => ({
    ...item,
    ID: item.ID,
  }));
  setItemArr(reorderedItems);
  handleCreateNewOption("updateSections",reorderedItems);
  setDraggedIndex('');
  setHoveredDropZone(null); // Reset hovered drop zone
};

const handleDragOver = (e, index) => {
  e.preventDefault();
   // Set the hovered drop zone
};

const handleDragEnd = () => {
  setDraggedIndex('');
  setHoveredDropZone(null); // Clear hovered drop zone
};
   const fireGetOptionsDataByQuestionId=()=>{
   setItemArrLoading([{},{}])
    setItemArr([])
    setLoader({status:true});
    
      const apiData = dispatch(getOptionsByQuestionId({optionText:"",type:"option",questionType:questionType,
        postParent:questionObject?.ID,userEmail:user_email?user_email:"",
        currentToken:currentToken?currentToken:"",
        editType:"",postId:questionObject?.ID,menuOrder:"0",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken,visibility:visibility}
        ));
      /* get response as Promise   */
      apiData.then(response => {
        if(response){  
            // console.log(response)
          if(response?.options){
            setItemArrLoading([])
        setResponseMessage(response?.message);  
        setSnackbarColor("rgba(144, 202, 249,1)");
      
         setItemArr( response?.options?.length?response?.options:questionType=="NAT"||questionType=="Drag Matching"?[newOption]:questionType=="True-False"?newOptionFT:[])
if(response?.options?.length){}else{isObjectNew(true)}
       }else{
        setResponseMessage("Something Went Wrong...");
          
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)
       }
          
       
       if(response?.logout){
       
        setResponseMessage("You are Logged Out!!!");
          
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)
        setTimeout(()=>{
          dispatch({type:"LOGOUT"});
    
        },3000)
        
      }
    /* resetting Login input Fields */
    
        }else{
          setResponseMessage("Something Went Wrong...");
          
          setSnackbarColor("#958FDA");
       
           
      setLoader({status:false});
      
      setSnackbarVisible(true);
      setTimeout(()=>{
        
        setSnackbarVisible(false);
       
         
      },3000)    }
    
      }).catch(error => {
     
        //popup of error Info
        setResponseMessage("Something Went Wrong...");
          
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)
        console.error(error);
      });
     
      }

     
  const handleCreateNewOption=(editType,val,optionId)=>{
     let SendObject=""
     if(editType=="optionAll"){
        SendObject={
          optionText:val?.optionText,
          optionImg:val?.optionImg,
          partialMarks:val?.partialMarks,
          displayType:val?.displayType,
          dropdownValues:val?.dropdownValues,
          isAllowPartialMarks:val?.isAllowPartialMarks,
          isCorrect:val?.isCorrect,
          textBoxValue:val?.textBoxValue,
          optionBoxAlign:val?.optionBoxAlign,
          isSingleRange:val?.isSingleRange,
          optionSingle:val?.optionSingle,
          optionRange:val?.optionRange,
          dragOrder:val?.dragOrder,
          questionType:questionType,type:"option",
            postParent:questionObject?.ID,userEmail:user_email?user_email:"",
            currentToken:currentToken?currentToken:"",
            editType:optionId?editType:"",postId:optionId,menuOrder:"0",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
             }
            
             if(editType=="optionText"){
        SendObject={optionText:val,questionType:questionType,type:"option",
            postParent:questionObject?.ID,userEmail:user_email?user_email:"",
            currentToken:currentToken?currentToken:"",
            editType:optionId?editType:"",postId:optionId,menuOrder:"0",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
             }
                if(editType=="optionImg"){
        SendObject={optionImg:val,questionType:questionType,type:"option",
            postParent:questionObject?.ID,userEmail:user_email?user_email:"",
            currentToken:currentToken?currentToken:"",
            editType:optionId?editType:"",postId:optionId,menuOrder:"0",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
             }
             
             if(editType=="displayType"){
        SendObject={displayType:val,questionType:questionType,type:"option",
            postParent:questionObject?.ID,userEmail:user_email?user_email:"",
            currentToken:currentToken?currentToken:"",
            editType:optionId?editType:"",postId:optionId,menuOrder:"0",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
             } if(editType=="optionBoxAlign"){
        SendObject={optionBoxAlign:val,questionType:questionType,type:"option",
            postParent:questionObject?.ID,userEmail:user_email?user_email:"",
            currentToken:currentToken?currentToken:"",
            editType:optionId?editType:"",postId:optionId,menuOrder:"0",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
             }
            
         if(editType=="isCorrect"){
        SendObject={isCorrect:val,questionType:questionType,type:"option",
            postParent:questionObject?.ID,userEmail:user_email?user_email:"",
            currentToken:currentToken?currentToken:"",
            editType:optionId?editType:"",postId:optionId,menuOrder:"0",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
             }
         if(editType=="optionSingle"){
        SendObject={optionSingle:val,questionType:questionType,type:"option",
            postParent:questionObject?.ID,userEmail:user_email?user_email:"",
            currentToken:currentToken?currentToken:"",
            editType:optionId?editType:"",postId:optionId,menuOrder:"0",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
             }
             
              if(editType=="optionRange"){
        SendObject={optionRange:JSON.stringify(val),questionType:questionType,type:"option",
            postParent:questionObject?.ID,userEmail:user_email?user_email:"",
            currentToken:currentToken?currentToken:"",
            editType:optionId?editType:"",postId:optionId,menuOrder:"0",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
             }
       
              if(editType=="isSingleRange"){
                
        SendObject={isSingleRange:val,questionType:questionType,type:"option",
            postParent:questionObject?.ID,userEmail:user_email?user_email:"",
            currentToken:currentToken?currentToken:"",
            editType:optionId?editType:"",postId:optionId,menuOrder:"0",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
             }
         if(editType=="textBoxValue"){
        SendObject={textBoxValue:val,questionType:questionType,type:"option",
            postParent:questionObject?.ID,userEmail:user_email?user_email:"",
            currentToken:currentToken?currentToken:"",
            editType:optionId?editType:"",postId:optionId,menuOrder:"0",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
             }
           
         if(editType=="isAllowPartialMarks"){
        SendObject={isAllowPartialMarks:val,questionType:questionType,type:"option",
            postParent:questionObject?.ID,userEmail:user_email?user_email:"",
            currentToken:currentToken?currentToken:"",
            editType:optionId?editType:"",postId:optionId,menuOrder:"0",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
             }if(editType=="partialMarks"){
        SendObject={partialMarks:val,questionType:questionType,type:"option",
            postParent:questionObject?.ID,userEmail:user_email?user_email:"",
            currentToken:currentToken?currentToken:"",
            editType:optionId?editType:"",postId:optionId,menuOrder:"0",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
             }
             
             
             if(editType=="deleteItem"){
        SendObject={visibility:val,questionType:questionType,type:"option",
            postParent:questionObject?.ID,userEmail:user_email?user_email:"",
            currentToken:currentToken?currentToken:"",
            editType:optionId?editType:"",postId:optionId,menuOrder:"0",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
             }
             
            
              // console.log(SendObject);
            
                                                                             
     setLoader({status:true});
     
       const apiData = dispatch(createNewQuestionsOption(SendObject));


       /* get response as Promise   */
       apiData.then(response => {
         if(response){   
            // console.log(response)
           if(response?.option){
            if(editType=='optionText'){
   if(optionId==response?.option?.ID){}else{setItemArr([...itemArr,response?.option]); }
            }
 if(editType=='optionAll'){
  
            fireGetOptionsDataByQuestionId();
 }
            // else
            //  if(editType=='lockTime'){
            //     if(optionId==response?.option?.ID){}else{setItemArr([...itemArr,{...newOption,optionText:response?.option?.optionText}]); }
            //  }
            //  if(editType=="allSections"){
            //  setItemArr( response?.quiz?.allSections?JSON.parse(response?.quiz?.allSections):[])
            //  }
     setLoader({status:false});
     
     setTimeout(()=>{
       
       setSnackbarVisible(false);
     
        
     },1000)
        }else{
         setResponseMessage("Something Went Wrong...");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
        }
           
        
        if(response?.logout){
        
         setResponseMessage("You are Logged Out!!!");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
         setTimeout(()=>{
           dispatch({type:"LOGOUT"});
     
         },3000)
         
       }
     /* resetting Login input Fields */
     
         }else{
           setResponseMessage("Something Went Wrong...");
           
           setSnackbarColor("#958FDA");
        
            
       setLoader({status:false});
       
       setSnackbarVisible(true);
       setTimeout(()=>{
         
         setSnackbarVisible(false);
        
          
       },3000)    }
     
       }).catch(error => {
      
         //popup of error Info
         setResponseMessage("Something Went Wrong...");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
         console.error(error);
       });
      
       }
   
     return(<>
              {snackbarVisible && (
        <Snackbar message={responseMessage} color={snackbarColor}  onClose={hideSnackbar} />
      )} 
    <div > 
         {createNewOptionPopUp?
         <CreateQueOptionPopUp
         objectNew={objectNew}
         currentOption={currentOption} 
          setItemTitle={(id, optionText)=>{updateItemtitle(id, optionText,objectNew?"":id) ;}}
          setItemImg={(id, optionText)=>{updateItemImg(id, optionText,objectNew?"":id) ;}}
       updateDisplayType={(id, optionText)=>{updateDisplayType(id, optionText,objectNew?"":id) ;}}
       updateIsSingleRange={(id, optionText)=>{updateIsSingleRange(id, optionText,objectNew?"":id) ;}}
          setIsCorrectBack={(id, optionText)=>{updateIsCorrect(id, optionText,objectNew?"":id) ;}}
          
            setOptionSingleBack={(id, optionText)=>{updateOptionSingle(id, optionText,objectNew?"":id) ;}}
     setOptionRangeBack={(id, optionText)=>{updateOptionRange(id, optionText,objectNew?"":id) ;}}
          setTextBoxValueBack={(id, optionText)=>{updateTextBoxValueBack(id, optionText,objectNew?"":id) ;}}
          setIsAllowPartialMarksBack={(id, optionText)=>{updateIsAllowPartialMarks(id, optionText,objectNew?"":id) ;}}
          setPartialMarksBack={(id, optionText)=>{updatePartialMarks(id, optionText,objectNew?"":id) ;}}
          updateOptionBoxAlign={(id, optionText)=>{updateOptionBoxAlign(id, optionText,objectNew?"":id) ;}}
         sendBackData={(data)=>{ }} 
         closeOptionPopUp={()=>{ setCreateNewOptionPopUp(false);isObjectNew(false);fireGetOptionsDataByQuestionId()}}
         sendBackObject={(data)=>{ setCreateNewOptionPopUp(false);

         
            if(questionType=="True-False"){
                if(objectNew){
                  
                    handleCreateNewOption("optionAll",data?.optionText=="True"?data:newOptionFT[0],objectNew?"":data?.ID);
               handleCreateNewOption("optionAll",data?.optionText=="False"?data:newOptionFT[1],objectNew?"":data?.ID);
                }else{
                    handleCreateNewOption("optionAll",data,objectNew?"":data?.ID);
                }
              
            }else{
                  handleCreateNewOption("optionAll",data,objectNew?"":data?.ID);
               }
       
          //  setTimeout(()=>{fireGetOptionsDataByQuestionId();},objectNew?1000:1000);
         isObjectNew(false);
        }}
         />
          :""}
  {deleteSectionPopUp?<div>
    <div   onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}  style={{zIndex:99,cursor:"pointer",opacity:"0.2",background:"#000"}} 
      onClick={()=>setDeleteSectionPopUp(false)} className="appDesignPopUpOpacity"> </div>
         <div   className="AreYouSurePopUp" style={{height:"200px",borderRadius: '20px'}}> 
         <h1 align="center" >   Are You Sure? </h1>
       
  
 <div className="bookmarkListScroll" style={{overflowY:"auto",height:"180px",overflowX:"hidden"}}>
 
     <div className="">
 </div>
 
 <div align="center" className="" style={{position:"absolute",left:"0px",right:"0px",bottom:"18px",display:"flex",justifyContent:"space-between",alignContent:"center",textAlign:"center",gap:"10px",margin:"5px",
    
    transition: 'transform 2s ease, opacity 1s ease',
  }}><button onMouseEnter={handleMouseEnter}
   onMouseLeave={handleMouseLeave} onClick={(id)=>{setDeleteSectionPopUp(false)}}   className=" CoursesPreviewTopBtn"  type="submit"
   style={{border:"3px solid rgba(144, 202, 249,1)",color:"rgba(144, 202, 249,1)"}}> No </button>
 <button onMouseEnter={handleMouseEnter}
   onMouseLeave={handleMouseLeave} onClick={()=>{removeItem(deleteId);setDeleteSectionPopUp(false)}}  style={{position:"relative",background:"rgba(144, 202, 249,1)",color:"#fff",width:"200px",cursor:"pointer",zIndex:99999,height:"55px"}} 
   className=" CoursesPreviewTopBtn"  type="submit"
  >Yes. Delete this Option.</button>
 </div> 
 </div>
 
      </div>
 </div>:""}
    <div  className=""style={{margin:"10px"}}>
   
               <div  className=" " style={{borderRadius:"25px",}}>
  <div  className=" " >
    
  
<div  className=""style={{
     transform: animate ? 'translateY(0)' : 'translateY(-50px)',
     opacity: animate ? 1 : 0,
     transition: 'transform 2s ease, opacity 1s ease',
   }}>
{flattenedData?flattenedData.map((item, index) => 
        (<div  index={index} key={item.ID} 
          >
        <div
          className="drop-zone"
          onDragOver={(e) => {setHoveredDropZone(index);
            handleDragOver(e, index)
          }}
          onDrop={(e) => handleDrop(e, index)}
        
          style={{
            height: hoveredDropZone === index ?'60px':"0px",position:hoveredDropZone === index ?'relative':"",left:"10px",right:"0px",
            backgroundColor: hoveredDropZone === index ? 'rgba(149, 143, 218,0.2) ' : 'transparent', // Change color on hover
            border: hoveredDropZone === index ? '2px dashed rgba(149, 143, 218,1) ' : 'transparent', // Change color on hover
            transition: 'background-color  0.3s ease',width:"95%",
            borderRadius: '10px',marginBottom:hoveredDropZone === index ?"20px":"0px"
           
          }}
        ></div>
            <div
             draggable ={questionType=="Drag Matching"?false:true}
                    
onDragOver={(e) => { if(selectedItemIndex!==index&&questionType!=="Drag Matching"){setHoveredDropZone(index);
    handleDragOver(e, index)}
  }}
  onDrop={(e) => {if(selectedItemIndex!==index&&questionType!=="Drag Matching"){handleDrop(e, index);setSelectedItemIndex(null);}}}

             onDragStart={(e) =>{ 
              if(questionType!=="Drag Matching"){
                handleDragStart(e, index);
              setDraggedIndex(item.ID);setSelectedItemIndex(index);} 
             }}
               className={draggedIndex == item.ID?"posFixed":"posRelative"  }
          
              onDragEnd={handleDragEnd}
            ><MCQOptionDisplay questionType={questionType} element={item} setCurrentOption={()=>{setCurrentOption(item);setCreateNewOptionPopUp(true)}} setDeleteSectionPopUp={(id)=>{setDeleteSectionPopUp(true);setDeleteId(id)}} isLockSections={isLockSections} lockTimeSent={item.lockTime}
             changelockTime={(id,lockTime)=>updateItemlockTime(id, lockTime,item.ID)} index={index} key={item.ID} 
        
         optionText={item.optionText}  id={item.ID} 
           changeItemtitle={(id, optionText)=>updateItemtitle(id, optionText,item.ID) } onRemove={(id)=>removeItem(item.ID) } />
                </div>
          
          </div>)):'' }
  
   
    </div>  
     {flattenedDataLoading.length==0&&flattenedData.length==0&&questionType!=="Essay"? <div style={{fontSize:"28px",fontWeight:"bold",padding:"5px",marginTop:"45px",
                 paddingLeft:"10px",display:"flex",margin:"15px",justifyContent:"center",border:"3px solid rgba(144, 202, 249,0.41)",marginTop:"10px",background:"#ffffff",borderRadius:"15px",padding:"5px",
             display:"flex",justifyContent:"center"
            }}>
             No Option Found </div>:"" }
     { flattenedDataLoading?flattenedDataLoading?.map((item, index) => 
        (<div  index={index} key={index}    >
<SectionsQuizAddMoreLoading/></div>)):""}
     <div align="center">


{ questionType=="MCQ"||questionType=="MSQ"?
<div align="center"  style={{width:"240px",
     }}> 
      <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="" style={{marginTop:"15px",padding:"10px",}}>Add New Option </div>
      
      
  <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} onClick={()=>{setCreateNewOptionPopUp(true);setCurrentOption(newOption) ;setItemArr([...itemArr,newOption]) ;;isObjectNew(true) }}style={{width:"40px",height:"40px",cursor:"pointer",
        borderRadius:"50%",margin:"5px",marginBottom:"20px",
      background:"#958FDA"}} > <Plus  style={{margin:"9px"}}  color="#ffffff" size={22}/></div>
      </div>:""}
    </div>
    </div>   <div  className=""style={{
        transform: animate ? 'scale(1)' : 'scale(.9)',marginTop:"50px",
        opacity: animate ? 1 : 0,
        transition: 'transform 2s ease, opacity 1s ease',
      }}>
         

        </div>  </div>  </div>  </div> 

  
      
                                    
     </>)  
   }
   export default QuestionOptions;